import React, { useEffect } from "react";
import useSettings from "stores/settings";
import CompanyMap from "components/CompanyMap";
import ModalImage from "react-modal-image";

const Company = () => {
  const settings = useSettings();
  // const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    settings.currentMenu = "company";
    // setLoading(false);
  }, []);

  // if (isLoading) return <div></div>;

  return (
    <section className="section3 w-full h-full overflow-y-scroll section3_bg py-8">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 pt-14 pb-32">
        <History />
        <Certificate />
        <CompanyMap />
      </div>
    </section>
  );
};

const History = () => {
  return (
    <div className="px-2 xl:px-0 mt-10 mx-auto max-w-4xl bg-transparent text-white font-gmarket-medium">
      <div className="font-gmarket-bold text-2xl sm:text-3xl mb-16">기업 연혁</div>
      <ul className="historyEnkino keep-words">
        <li>
          <p className="mt-4 font-gmarket-bold">2011</p>
          <ul>
            <li className="ml-12 flex">
              <p>08</p>
              <span className="pl-4">법인설립</span>
            </li>
          </ul>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2012</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>12</strong>
                <span className="pl-4">네이버 앱스토어 2012년을 빛낸 베스트앱에 선정</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2013</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>05</strong>
                <span className="pl-4">특허등록 (동영상을 이용한 이동단말기의 배경화면 설정방법, 등록번호: 제 10-1263179)</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2014</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>07</strong>
                <span className="pl-4">토스(TOSS) 멀티미디어 메신저 출시 (다운로드 50만건)</span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>09</strong>
                <span className="pl-4">HSAD CHINA Ltd.에 LG G3 전용 라이브 월페이퍼 3종 납품 (수출 $26,000)</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2015</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>06</strong>
                <span className="pl-4">정보통신산업진흥원 ‘K-Global 스마트 모바일 스타기업 육성사업’ 과제 선정 </span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>09</strong>
                <span className="pl-4">벤처기업지정 (기술보증기금 기술평가보증기업, 제 20150110219호) </span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>12</strong>
                <span className="pl-4">현대자동차 디지털 쇼룸 파일 해외 배포 모듈 개발 납품 </span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>12</strong>
                <span className="pl-4">크린토피아 POS/PAD 연동 고객관리 솔루션 납품 (전국 2,000여개 매장에 설치)</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2016</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>09</strong>
                <span className="pl-4">정보통신산업진흥원 ‘K-Global 스마트 모바일 스타기업 육성사업’ 2차년도 선정</span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>11</strong>
                <span className="pl-4">삼성전자 협력업체 등록 (삼성전자 EyeGalaxy 솔루션 납품) </span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>12</strong>
                <span className="pl-4">K-Global 300기업에 선정 (미래창조과학부 제481호 인증) </span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2017</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>07</strong>
                <span className="pl-4">KEB하나은행 원큐랩 5기에 선정 </span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>12</strong>
                <span className="pl-4">KEB하나은행 미래금융사업본부 PoC 프로젝트 수행</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2018</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>01</strong>
                <span className="pl-4">하나카드 하나멤버스 V3 제로 UI 프로젝트 수행 </span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>03</strong>
                <span className="pl-4">
                  특허출원 (모션 인식을 이용한 금융 서비스를 제공하는 모바일 디바이스의 동작 방법 및 그 모바일 디바이스){" "}
                </span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>04</strong>
                <span className="pl-4">기업부설연구소 설립</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2019</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>06</strong>
                <span className="pl-4">NIPA 디지털콘텐츠기업 성장지원센터 10기 입주기업으로 선정 </span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>09</strong>
                <span className="pl-4">한국P&G 이노베이션 센터에 ‘모션인식을 활용한 P&G 제품 검색 데모 앱’ 납품</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2020</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>04</strong>
                <span className="pl-4">정보통신산업진흥원 ‘AI 바우처 공급기업’에 선정 (머신러닝) </span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>06</strong>
                <span className="pl-4">정보통신산업진흥원 ‘사물인터넷 제품 서비스 검증 확산사업’에 선정 (AI PHM) </span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>07</strong>
                <span className="pl-4">
                  중소벤처기업부 ‘중소기업기술혁신개발사업 시장대응형 과제’ 에 선정 (클라우드 기반의 손쉬운 인공지능 플랫폼)
                </span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2021</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>05</strong>
                <span className="pl-4">정보통신산업진흥원 ‘지능형 IoT 적용 확산 사업’에 선정 </span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2022</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>04</strong>
                <span className="pl-4">정보통신산업진흥원 ‘AI 바우처지원사업’ 2개 선정</span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>05</strong>
                <span className="pl-4">PCT 특허출원 (인공지능 클라우드 플랫폼 서비스 시스템 및 그 방법)</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2023</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>04</strong>
                <span className="pl-4">정보통신산업진흥원 ‘AI 바우처지원사업’ 선정</span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>04</strong>
                <span className="pl-4">기업부설연구소 R&D 역량 강화 지원사업 선정</span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>05</strong>
                <span className="pl-4">정보통신산업진흥원 공개SW 기업성장 지원사업 선정</span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>05</strong>
                <span className="pl-4">특허 1건 기술이전 (인하대학교)</span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>06</strong>
                <span className="pl-4"> 과학기술정보통신부 ICT R&D 바우처 사업 선정</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2024</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>05</strong>
                <span className="pl-4">정보통신산업진흥원 ‘AI 바우처지원사업’ 선정</span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>05</strong>
                <span className="pl-4">정보통신산업진흥원 유망 SaaS 육성 개발 지원사업 선정</span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>12</strong>
                <span className="pl-4">생성형 AI 서비스 빌드 SaaS 플랫폼 ‘AI Love School’ 서비스 오픈</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p className="mt-4 font-gmarket-bold">2025</p>
            <ul>
              <li className="font-gmarket-medium ml-12">
                <strong>03</strong>
                <span className="pl-4">(주)그렉터로부터 전략적 투자 유치</span>
              </li>
              <li className="font-gmarket-medium ml-12">
                <strong>05</strong>
                <span className="pl-4">정보통신산업진흥원 초거대 AI 기반 클라우드서비스 개발 역량지원 사업 선정</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  );
};

const Certificate = () => {
  return (
    <div className="mt-32 grid gap-2 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8">
      <ModalImage small={"images/certification/business.jpg"} large={"images/certification/business.jpg"} alt="전문연구사업자 신고증" />
      <ModalImage
        small={"images/certification/certificateOfPatent.png"}
        large={"images/certification/certificateOfPatent.png"}
        alt="특허증"
      />
      <ModalImage small={"images/certification/certificate.png"} large={"images/certification/certificate.png"} alt="특허증" />
      <ModalImage small={"images/certification/kibo.jpg"} large={"images/certification/kibo.jpg"} alt="벤처기업확인서" />
      <ModalImage small={"images/certification/koita.jpg"} large={"images/certification/koita.jpg"} alt="기업부설연구소 인정서" />
      <ModalImage small={"images/certification/kt1.png"} large={"images/certification/kt1.png"} alt="KT 상장" />
      <ModalImage small={"images/certification/kt11.png"} large={"images/certification/kt11.png"} alt="KT 인증서" />
      <div className="row">
        <div className="col s12 m12 px-1">
          <ModalImage
            small={"images/certification/kglobal1.png"}
            large={"images/certification/kglobal1.png"}
            alt="미래창조과학부 한글인증서"
          />
        </div>
        <div className="col s12 m12 px-1 pt-3">
          <ModalImage
            small={"images/certification/kglobal2.png"}
            large={"images/certification/kglobal2.png"}
            alt="미래창조과학부 영문인증서"
          />
        </div>
      </div>
    </div>
  );
};

export default Company;
